import { createMiddleware, createStart } from "@tanstack/react-start";
import { isIndexableEnv, withNoindexHeader } from "@/lib/indexing";

// Test/preview deploys are public, so every response tells crawlers not to index them.
const noindexOutsideProduction = createMiddleware().server(async ({ next }) => {
  const result = await next();
  if (isIndexableEnv(process.env.VITE_APP_ENV)) return result;
  return { ...result, response: withNoindexHeader(result.response) };
});

export const startInstance = createStart(() => ({
  requestMiddleware: [noindexOutsideProduction],
}));
